export const LOGO_FULL =
  "https://customer-assets.emergentagent.com/job_dec08424-fc73-49b9-baa8-aa3ba66b35db/artifacts/4uz2b6wy_vector%20logo%20file.png";
export const LOGO_ICON =
  "https://customer-assets.emergentagent.com/job_dec08424-fc73-49b9-baa8-aa3ba66b35db/artifacts/es0tvjal_small%20icon%20logo.png";
export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/dec08424-fc73-49b9-baa8-aa3ba66b35db/images/7b7688e84296495b5770341294bbaf3b88aac3b9ffc8c94844cea0750693f09b.png";
export const CLEANING_IMAGE =
  "https://images.unsplash.com/photo-1689127903369-aef916b0c40d?fm=jpg&q=80&w=1400&fit=crop&ixlib=rb-4.1.0";
export const HANDYMAN_IMAGE =
  "https://images.unsplash.com/photo-1756027583186-a04a19e4f6ce?fm=jpg&q=80&w=1400&fit=crop&ixlib=rb-4.1.0";

export const PHONE_DISPLAY = "423-303-9766";
export const PHONE_TEL = "+14233039766";
export const EMAIL = "Heavenlyhomeandoffice@gmail.com";
export const SERVICE_AREA = "Chattanooga, TN & surrounding areas";
export const SERVICE_COUNTIES = ["Hamilton", "Bradley", "Catoosa", "Meigs"];

export const SERVICE_TYPES = [
  "Cleaning",
  "Handyman",
  "Yard/Exterior",
  "Tech/AV",
  "Event Setup/Cleanup",
  "Other",
];

export const FREQUENCIES = ["One-time", "Weekly", "Bi-Weekly", "Monthly", "Not sure"];

export const LEAD_STATUSES = ["New", "In Progress", "Completed", "Archived"];
